<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='角色信息查询'></PageHead>
      <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
        <AddButton url="/system/role/add"></AddButton>
      </div>
      <div class="m-portlet__body">
        <!--begin: Datatable -->
        <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
          <el-table-column prop="RoleName" label="角色名称">
          </el-table-column>
          <el-table-column prop="RoleDesc" label="角色描述" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="RoleLevel" label="角色级别">
            <template slot-scope="scope">
              <span v-if="scope.row.RoleLevel === 1">个人</span>
              <span v-else-if="scope.row.RoleLevel === 2">科室</span>
              <span v-else-if="scope.row.RoleLevel === 3">单位</span>
              <span v-else-if="scope.row.RoleLevel === 4">区域</span>
              <span v-else>管理员</span>
            </template>
          </el-table-column>
          <el-table-column prop="RoleType" label="角色类型" width="150px">
            <template slot-scope="scope">
              <span v-if="scope.row.RoleType === 1">内置角色</span>
              <span v-else>自定义角色</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="UserTypeRange" label="用户类型范围" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="HosRange" label="单位范围" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column label="操作" width="100px">
            <template slot-scope="scope">
              <el-button @click="Edit(scope.row)" type="text" size="medium" v-if="scope.row.RoleType === 2">修改</el-button>
              <el-button @click="Delete(scope.row)" type="text" size="medium" v-if="scope.row.RoleType === 2">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--end: Datatable -->
      </div>
    </div>
    <div style="display: none;"><SearchButton :url="SearchButton" ref="btnSearch"></SearchButton></div>
  </div>
</template>

<script>
export default{
  name: 'RoleList',
  data () {
    return {
      condition: {
        token: '',
        currentPage: 1,
        pageSize: 100,
        recordCount: 0
      },
      tableData: null,
      SearchButton: this.$utils.Url.system + '/systemapi/role/list',
      loading: true
    }
  },
  mounted: function () {
    this.condition.token = sessionStorage.getItem('token')
    this.$refs.btnSearch.Search()
  },
  methods: {
    Edit: function (row) {
      this.$router.push({name: 'RoleEdit', params: {id: row.RoleID}})
    },
    Delete: function (row) {
      var args = {
        id: row.RoleID,
        token: this.condition.token
      }
      this.$utils.Delete(this.$utils.Url.system + '/systemapi/role/delete', args, row.DictItemName, this.$refs.btnSearch.Search)
    }
  }
}
</script>

<style>
</style>
